import React, { useState, useEffect, Fragment } from "react";
import { GetData, SearchData, DeletData } from "./Components/Services";
import DataTable from "../../../Common/Components/DataTable";
import { set } from "lodash";
import Loading from "../../../Common/Components/Loading";

function List() {
  const [state, setstate] = useState({
    loading: false,
    data: "",
  });
  const [filters, setfilters] = useState({
    product_type: null,
  });
  const Handler = (pageNumber = 1, limit, filter) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, limit, filter).then(res => {
      setstate({ loading: false, data: res });
    });
  };
  const HandlerSearch = data => {
    setstate({ ...state, loading: true });
    SearchData({ code: data }).then(data => {
      setstate({ loading: false, data: data });
    });
  };
  const handlerDelet = data => {
    setstate({ ...state, loading: true });
    DeletData(data).then(
      GetData().then(data => {
        setstate({ loading: false, data: data });
      })
    );
  };
  useEffect(() => {
    Handler();
  }, []);

  return (
    <>
      <DataTable
        filter={true}
        loading={state.loading}
        header="لیست کد تخفیف"
        heads={[
          { title: "کد تخفیف", key: "code" },
          { title: "توضیحات", key: "description" },
          { title: "تاریخ شروع", key: "pro_time" },
          { title: "تاریخ پایان", key: "exp_time" },
          {
            title: "نوع تخفیف ",
            key: "type_discount",
            type: "enum",
            enum: {
              money: "پولی",
              percentage: "درصدی",
            },
          },
          {
            title: "برای کلاب",
            key: "forclup",
            type: "enum",
            enum: {
              0: "نیست ",
              1: "هست",
            },
          },
          {
            title: "نوع محصول ",
            key: "product_type",
            type: "enum",
            enum: {
              all: "همه ",
              plans: "فروش مجموعه",
              reserve: "رزرواسیون",
              joinclass: "ثبت نام در کلاس",
              contractual_reservation: "رزرو قراردادی",
            },
          },
        ]}
        textEmpty="کد تخفیفی  ثبت نشده است"
        list={state.data && state.data.data}
        data={state.data}
        function={Handler}
        search={HandlerSearch}
        links={[
          {
            html: (
              <Fragment>
                <select
                  onChange={e => {
                    Handler(null, null, {
                      ...filters,
                      product_type: e.target.value,
                    });
                  }}
                  className="form-control col-12"
                >
                  <option value="0">همه نوع محصول</option>
                  <option value={"joinclass"}>ثبت نام در کلاس</option>
                  <option value={"reserve"}>رزرواسیون</option>
                  <option value={"contractual_reservation"}>
                    {" "}
                    رزرو قرادادی
                  </option>
                </select>
              </Fragment>
            ),
          },

          {
            function: selected => {
              handlerDelet({ offer_id: selected });
            },
            color: "danger",
            size: "col-md-4",
            html: "حذف",
            undisabled: true,
            typeLink: "sort",
            type: "delete",
          },
        ]}
      />
    </>
  );
}

export default List;
